<template>
  <component
    class="dsf-div-editor"
    :is="tag"
    :placeholder="placeholder"
    :contenteditable="filterStyle == 'text' ? 'plaintext-only' : 'true'"
    @click.stop
    @blur="onBlur"
    @focus="onFocus"
    @input="onInput"
    @paste="onPaste"
  />
</template>

<script>
export default {
  name: "DsfDivEditor",
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请输入'
    },
    filterStyle: {
      type: String,
      default: null
    }
  },
  watch: {
    value(to) {
      if (this.$el && this.$el.innerHTML !== to) {
        this.$el.innerHTML = to;
      }
    }
  },
  created() {
    this.onInput = _.throttle(this._onInput, 80);
  },
  mounted() {
    this.$el.innerHTML = this.value || '';
  },
  methods: {
    _onInput() {
      if (this.__paste) {
        this.__paste = false;
        this.$el.innerHTML = filterHtml(this.$el.innerHTML);
      }
      let html = this.$el.innerHTML;
      let text = this.$el.innerText.replace(/[\n\r]/, '');
      let val = this.filterStyle == 'text' ? text : html;
      let dom = this.$el.querySelector('img,table,video,audio');
      if (!dom && (!this.$el.innerText || this.$el.innerText === '\n')) {
        val = '';
      }
      this.$emit('html', html);
      this.$emit('text', text);
      this.$emit('input', val);
    },
    onPaste() {
      if (this.filterStyle == 'style') {
        this.__paste = true;
      }
    },
    onBlur(event) {
      let html = this.$el.innerHTML;
      let text = this.$el.innerText.replace(/[\n\r]/, '');
      let value = this.filterStyle == 'text' ? text : html;
      this.$emit('change', value);
      this.$emit('blur', {
        value,
        html,
        text,
        target: this.$el,
        vm: this,
        event
      });
    },
    onFocus(event) {
      let val = this.value;
      this.$emit('focus', {
        value: val,
        target: this.$el,
        vm: this,
        event
      });
    },
    focus() {
      setTimeout(() => {
        this.$el.focus();
      }, 0);
    },
    blur() {
      this.$el.blur();
    }
  }
}

const htmlFilterEl = document.createElement("div");
const mediaTag = ['img','video', 'audio'];
const scriptTag = ['script','style'];
const formTag = ['input','textarea','select'];
const inlineTag = ['a','label','code','abbr','em','b','big','cite','i','q','small','span','sub','sup','strong','u','li','ins','del','dfn','kbd','var'];
const tableTag = {
  table: ['style', 'align', 'cellpadding', 'cellspacing', 'frame', 'rules', 'summary', 'width', 'border'],
  thead: ['align', 'char', 'charoff', 'valign'],
  tbody: ['align', 'char', 'charoff', 'valign'],
  tfoot: ['align', 'char', 'charoff', 'valign'],
  caption: ['align'],
  col: ['align', 'char', 'charoff', 'valign', 'span', 'width'],
  colgroup: ['align', 'char', 'charoff', 'valign', 'span', 'width'],
  tr: ['style', 'align', 'char', 'charoff', 'valign'],
  th: ['style', 'abbr', 'align', 'axis', 'char', 'charoff', 'colspan', 'headers', 'rowspan', 'scope', 'valign', 'width'],
  td: ['style', 'abbr', 'align', 'axis', 'char', 'charoff', 'colspan', 'headers', 'rowspan', 'scope', 'valign', 'width'],
}
function filterHtml(html) {
  htmlFilterEl.innerHTML = html || '';
  return getHtml(htmlFilterEl.childNodes);
}
function getHtml(childNodes) {
  let res = _.map(childNodes, node => {
    let nodeName = node.nodeName.toLowerCase();
    if (scriptTag.indexOf(nodeName) > -1 && formTag.indexOf(nodeName) > -1) {
      return '';
    }
    if (mediaTag.indexOf(nodeName) > -1) {
      return node.outerHTML;
    }
    if (nodeName == '#text') {
      return node.textContent;
    }
    if (node.childNodes) {
      if (inlineTag.indexOf(nodeName) > -1) {
        return getHtml(node.childNodes);
      }
      if (tableTag[nodeName]) {
        return `<${nodeName} ${getAttr(node, tableTag[nodeName])}>${getHtml(node.childNodes)}</${nodeName}>`;
      }
      return `<div>${getHtml(node.childNodes)}</div>`;
    }
    return node.innerText || '';
  });
  return res.join('');
}
function getAttr(node, attrs) {
  let arr = [];
  _.each(attrs, att => {
    let val = node.getAttribute(att);
    if (val) {
      if (att == 'style') {
        val = val.replace(/(font|backgrount|(;|\s)color|border([\-\w]*)-color)[:_\-\d\w\s()#]*;?/g, '');
      }
      arr.push(`${att}="${val}"`);
    }
  });
  return arr.join(' ');
}
</script>